<template>
  <div class="py-4">
    <b-container>
      <BDXUploader
        v-if="showUploader"
        @files-uploaded="onFilesUploaded"
        class="mb-3"
        multiple
      />

      <datarows-viewer
        ref="datarowsViewer"
        :fields="tableFields"
        :filters="filters"
        :api-url="`/lincoln/export/data/`"
        :api-headers="apiHeaders"
        :api-extra-payloads="apiExtraPayloads"
      >
        <template #header-left>
          <SavedReportsDropdown
            @edit="showCreateReportModal = true"
            class="mb-3 my-lg-1"
          />

          <!-- <DateRangeByFieldDropdown
					v-model="dateRangeSelected"
					:fields="dateRangeFields"
					class="drv-search-bar mb-3 mb-lg-0 ml-lg-auto mr-lg-3 my-lg-1"
				/> -->
        </template>
        <template #header-right>
          <b-button
            @click.prevent="showCreateReportModal = !showCreateReportModal"
            variant="primary"
            class="drv-btn my-lg-1"
            pill
            >Create Report</b-button
          >
        </template>
      </datarows-viewer>

      <modal
        :show.sync="showCreateReportModal"
        size="lg"
        bodyClasses="pt-0 px-4 pb-3"
        footerClasses="d-none"
      >
        <template #header>
          <h4 class="mb-0">Create Report</h4>
        </template>

        <ExportWizard
          ref="exportWizard"
          @report-exported="onReportExported"
          :export-id="exportItem.id"
          :edit-mode="exportItem.id ? true : false"
          :flags="exportFlags"
          :category="exportCategory"
          :columns="exportColumns"
          :params="filtersParams"
        />
      </modal>
    </b-container>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css'

import axios from 'axios'
import { mapGetters } from 'vuex'
import { userMixin } from '@mixins'
import { ExportsService } from '@services'
import { default as columns } from '@components/SaveReportWizard/utils/exportColumns'
import { BDXUploader } from '@components/bdx'
import { DatarowsViewer } from '@components/DatarowsViewer'
import ExportWizard from '@components/ExportWizard/ExportWizard'
import SavedReportsDropdown from '@components/SavedReportsDropdown'
import DateRangeByFieldDropdown from '@components/DateRangeByFieldDropdown'

export default {
  components: {
    DatarowsViewer,
    ExportWizard,
    SavedReportsDropdown,
    DateRangeByFieldDropdown,
    BDXUploader
  },
  mixins: [userMixin],
  data() {
    return {
      filters: [],
      filtersParams: [],
      showUploader: false,
      showCreateReportModal: false,
      exportColumns: [],
      exportCategory: undefined,
      exportFlags: ['3'],
      dateRangeSelected: null
    }
  },
  computed: {
    ...mapGetters(['exportItem']),
    tableFields() {
      return columns.map((item) => ({
        key: item.value,
        label: item.text,
        sortable: item.sortable,
        width: item.width,
        decimals: item.decimals || null,
        isDate: item.isDate || false
      }))
    },
    columnsToShow() {
      return columns.map((item) => item.value)
    },
    apiBaseURL() {
      return ''
    },
    apiHeaders() {
      return {}
    },
    apiExtraPayloads() {
      return {
        columns_to_show: this.columnsToShow,
        role: this.companyRole,
        role_value: this.companyRoleValue,
        parameters: this.filtersParams
      }
    },
    dateRangeFields() {
      return columns
        .filter((item) => item.isDate)
        .map((item) => ({ text: item.text, value: item.value }))
    }
  },
  methods: {
    async getParameters() {
      this.$nextTick(async () => {
        if (this.$refs.datarowsViewer)
          this.$refs.datarowsViewer.$emit('processing', true)

        const rs = await axios({
          url: `/get/parameters/`,
          method: 'POST',
          data: this.apiExtraPayloads
        })

        this.filters = Object.entries(rs.data.data).map((item) => {
          const name = item[0]
          const options = item[1].filter((oitem) => oitem)

          return {
            name: name,
            label: name.replace(/_/g, ' '),
            options: options
          }
        })

        if (this.$refs.datarowsViewer)
          this.$refs.datarowsViewer.$emit('processing', false)
      })
    },
    onFilesUploaded() {
      setTimeout(() => {
        this.showUploader = false
      }, 2000)
    },
    onReportExported() {
      this.showCreateReportModal = false

      this.$router.push({ name: 'PreviousReports' })
    }
  },
  watch: {
    exportItem(newVal) {
      if (!newVal.payload) return

      this.exportColumns = newVal.payload.columns_to_show
      this.exportCategory = newVal.payload.export_by
      this.exportFlags = newVal.payload.flag.map((item) =>
        item.value.toString()
      )

      this.filtersParams = newVal.payload.parameters

      this.showCreateReportModal = true
    },
    showCreateReportModal(newVal) {
      if (!newVal) ExportsService.unsetExport()
    },
    dateRangeSelected(newVal) {
      if (!this.$refs.datarowsViewer || (!newVal.value[0] && !newVal.value[1]))
        return

      this.$refs.datarowsViewer.currentPage = 1
      this.$set(
        this.$refs.datarowsViewer.filterParameters,
        newVal.key,
        `${newVal.value[0]},${newVal.value[1]}`
      )
    }
  },
  mounted() {
    ExportsService.unsetExport()
    this.getParameters()

    if (this.$refs.datarowsViewer) {
      this.$watch('$refs.datarowsViewer.cpQuery.parameters', {
        deep: true,
        handler(newVal) {
          this.filtersParams = newVal

          this.getParameters()
        }
      })

      this.$watch('$refs.datarowsViewer.toggledColumns', {
        handler(newVal) {
          this.exportColumns = newVal
        }
      })
    }

    this.$emitter.on('export-upload', (payload) => {
      if (!payload) return

      this.showUploader = !this.showUploader
    })
  }
}
</script>
